import { render, staticRenderFns } from "./ProductColor.vue?vue&type=template&id=078ec4da&functional=true"
import script from "./ProductColor.vue?vue&type=script&lang=js"
export * from "./ProductColor.vue?vue&type=script&lang=js"
import style0 from "./ProductColor.vue?vue&type=style&index=0&id=078ec4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports